module.exports = __webpack_public_path__ + "static/media/hab9-0.6b8431fb.jpg";